import * as swcHelpers from '@swc/helpers';
import { FacetId } from '../../types.js';
import { queryStringToQueryObject, PRICE_FROM_PARAM, PRICE_TO_PARAM } from './query-string.js';

function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((result, key)=>{
        result[key.toLowerCase()] = obj[key];
        return result;
    }, {});
}
function addFacetVisibility(facets, locale, presetQueryString) {
    const presetKeyVal = Object.entries(queryStringToQueryObject(presetQueryString || '', {
        facets
    })).reduce((result, [key, value])=>{
        result[key.toLowerCase()] = value;
        return result;
    }, {});
    return facets.map((facet)=>{
        const rawValue = presetKeyVal[facet.id.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue : rawValue ? [
            rawValue
        ] : [];
        let hidden = facet.hidden || !!value.length;
        if (facet.id === FacetId.price) {
            const hasPriceFrom = presetKeyVal.hasOwnProperty(PRICE_FROM_PARAM.toLowerCase());
            const hasPriceTo = presetKeyVal.hasOwnProperty(PRICE_TO_PARAM.toLowerCase());
            hidden = hidden || hasPriceFrom || hasPriceTo;
        }
        return swcHelpers.objectSpread({}, facet, {
            options: facet.options && lowercaseKeys(facet.options),
            value: value.length ? value : undefined,
            attribute: facet.isLocalized ? `${facet.attribute}_${locale}` : facet.attribute,
            hidden
        });
    });
}

export { addFacetVisibility };
//# sourceMappingURL=add-facet-visibility.js.map
